import { ButtonElement } from '../shared/buttonElement/ButtonElement';
import type { SubscriptionActionsElementProps } from './SubscriptionActionsElement.types';

export function SubscriptionActionsElement(props: SubscriptionActionsElementProps) {
  const {
    translations,
    unsubscribeEmphasis = 'button',
    onClickUnsubscribe,
    onClickResubscribe,
    onClickUnpause,
    onClickUpgradePlan,
    onClickLogin,
    onClickReportUnwantedSignup,
  } = props;

  if (onClickLogin) {
    return (
      <div className="flex w-full justify-center">
        <ButtonElement variant="default" onClick={onClickLogin}>
          {translations?.['shared.cta.login_to_continue']}
        </ButtonElement>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2 lg:flex-row justify-between">
      {onClickResubscribe && (
        <ButtonElement variant="flush" onClick={onClickResubscribe} className="underline">
          {translations?.['shared.cta.resubscribe']}
        </ButtonElement>
      )}
      <div className="flex flex-col gap-2 lg:flex-row">
        {onClickUnsubscribe && (
          <ButtonElement
            variant={unsubscribeEmphasis === 'link' ? 'flush' : 'danger-light'}
            onClick={onClickUnsubscribe}
            className={unsubscribeEmphasis === 'link' ? 'underline' : undefined}
          >
            {translations?.['shared.cta.unsubscribe']}
          </ButtonElement>
        )}
        {onClickReportUnwantedSignup && (
          <ButtonElement variant="flush" onClick={onClickReportUnwantedSignup} className="underline">
            {translations?.['shared.cta.report_abuse']}
          </ButtonElement>
        )}
        {onClickUnpause && (
          <ButtonElement variant="default" onClick={onClickUnpause}>
            {translations?.['shared.cta.unpause']}
          </ButtonElement>
        )}
      </div>

      {onClickUpgradePlan && (
        <div className="flex flex-col gap-2 lg:flex-row">
          <ButtonElement variant="primary" onClick={onClickUpgradePlan}>
            {translations?.['billing.free_plan.upgrade_plan']}
          </ButtonElement>
        </div>
      )}
    </div>
  );
}
